// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import FlashMessageActions from 'shared/actions/FlashMessageActions';

const Wrapper = props => (
  <Page title="User Details">
    <Row>
      <Show {...props} />
    </Row>
  </Page>
);

export default Wrapper;

class Show extends Component {
  constructor() {
    super();
    this.state = {
      staffEmployment: null,
    };
    this.resetPassword = this.resetPassword.bind(this);
  }

  componentDidMount() {
    api
      .get(`/agent_portal/api/staff_employments/${this.props.params.staff_employment_id}`)
      .then(response => {
        this.setState({ staffEmployment: response.data });
      });
  }

  resetPassword() {
    if (window.confirm('Are you sure?')) {
      api
        .post(`/agent_portal/api/agents/${this.state.staffEmployment.agentId}/password_resets`)
        .then(response => {
          FlashMessageActions.flashSuccess({
            message: `You have successfully initiated a password reset email for ${this.state.staffEmployment.name}`,
          });
        });
    }
  }

  render() {
    const { staffEmployment } = this.state;
    if (!staffEmployment) return <LoadingContent />;
    return (
      <Widget title={staffEmployment.name} span={5}>
        <table className="table table-bordered table-striped" data-spec-id="user-details">
          <tbody>
            <tr>
              <td>Role</td>
              <td>{staffEmployment.roleName}</td>
            </tr>
            <tr>
              <td>Practices/Locations</td>
              <td>{staffEmployment.entityNames.join(', ')}</td>
            </tr>
          </tbody>
        </table>
        <button onClick={this.resetPassword} className="btn btn-primary">
          Send Reset Password Email
        </button>
      </Widget>
    );
  }
}
